import { toCamelCaseKeys } from '@iichi/helper/object';
import axios from '@/js/lib/helper/axios';
import { updateToken } from './update_token';

export interface Item {
  itemId?: number;
  title?: string;
  price?: number;
  imagePath?: string;
  published?: boolean;
  stock?: number;
  shopId?: number;
  memberName?: string;
  aliasOrSlug?: string;
}

export interface ItemOption {
  itemOptionSlug: string;
  name: string;
  required: 0 | 1;
  itemOptionVariants: ItemOptionVariant[];
}

interface ItemOptionVariant {
  itemOptionVariantSlug: string;
  name: string;
  price: number;
}

export interface ShippingPlanOfItem {
  shippingMethodName: string;
  shipFrom: string;
  isUniform: boolean;
  isTracable: boolean;
  isReparative: boolean;
  fees: {
    shipTo: string;
    areaName: string;
    fee: number;
  }[];
  feeOnBulkbuying: number;
}

interface ItemLiked {
  itemId: string;
  liked: 0 | 1;
}

export const isItemLiked = async ({ itemIds }: { itemIds: number[] }): Promise<ItemLiked[]> => {
  const res = await axios.get('/api/is-liked/items', {
    params: {
      item_ids: itemIds.join(','),
    },
  });
  return toCamelCaseKeys(res.data);
};

export const likeItem = async ({ itemId }: { itemId: number }): Promise<''> => {
  const token = await updateToken();
  const params = new URLSearchParams();
  params.append('item_id', String(itemId));
  params.append('token', token);
  const res = await axios.post('/api/like/item', params);
  return res.data;
};

export const unlikeItem = async ({ itemId }: { itemId: number }): Promise<''> => {
  const token = await updateToken();
  const params = new URLSearchParams();
  params.append('item_id', String(itemId));
  params.append('token', token);
  const res = await axios.post('/api/like/unlink/item', params);
  return res.data;
};

export const requestStart = async ({ itemId, email, followMember, mailMagazine }: { itemId: number; email: string; followMember: boolean; mailMagazine: boolean }): Promise<''> => {
  const token = await updateToken();
  const params = new URLSearchParams();
  params.append('item_id', String(itemId));
  params.append('token', token);
  params.append('address', email);
  if (followMember) {
    params.append('follow_member', 'true');
  }
  if (mailMagazine) {
    params.append('other_notifications', 'true');
  }
  const res = await axios.post('/api/request/start', params);
  return res.data;
};

export const getShippingPlans = async (itemId: number): Promise<{ shippingPlans: ShippingPlanOfItem[] }> => {
  const res = await axios.get(`/api/item/${itemId}/shipping-plans`);
  return toCamelCaseKeys(res.data);
};
